import React from 'react';
import { Breadcrumb, Space, Typography } from 'antd';

interface PageHeaderProps {
    eyebrow?: string;
    title: string;
    description?: string;
    extra?: React.ReactNode;
}

const PageHeader = ({ eyebrow, title, description, extra }: PageHeaderProps) => (
    <div className="v2-page-header">
        <div className="v2-page-header__copy">
            {eyebrow && (
                <Breadcrumb>
                    <Breadcrumb.Item>{eyebrow}</Breadcrumb.Item>
                </Breadcrumb>
            )}
            <Typography.Title level={2}>{title}</Typography.Title>
            {description && <Typography.Paragraph>{description}</Typography.Paragraph>}
        </div>
        {extra && <Space className="v2-page-header__extra">{extra}</Space>}
    </div>
);

export default PageHeader;
